import { isEmpty } from 'lodash/fp';

export const requiredStrategy = (value: string | undefined | null) => {
  return !isEmpty(value);
};
